import React, { RefObject } from "react"
import { ChatInputTextAreaRef } from "@/components/ChatInput"
import { Message, MessageGroup } from "@/reducers/messagesSlice"

export type ChatHistoryContext = {
  messageHighlight: { messageId: string; animationKey: string } | undefined
  jumpAndHighlightMessage: (messageId: string) => void
  chatInputRef: RefObject<ChatInputTextAreaRef>
  expandImageGroup: (messageOrMessageGroup: Message | MessageGroup) => void
  isForwardingMode: boolean
  selectedMessageIds: Set<string>
  enterForwardingMode: (messageIds: string[]) => void
  exitForwardingMode: () => void
  toggleMessageSelection: (messageIds: string[]) => void
  handleForwardMessages: () => void
}

export const ChatHistoryContext = React.createContext({} as ChatHistoryContext)
